import React from 'react';
import { Popover } from '@milanote/roma';
import LabelsSearchBar from '../components/LabelsSearchBar';
import LabelLists from '../components/LabelLists';
import useLabelsTool from '../hooks/useLabelsTool';
import { LabelsToolbarPopupProps } from '../labelComponentPropTypes';

const LabelsToolbarPopupContent: React.FC<LabelsToolbarPopupProps> = (props) => {
    const {
        allLabels,
        elements,
        searchString,
        setSearchString,
        handleCreateLabel,
        handleSearchSubmit,
        handleToggleLabelSelection,
    } = useLabelsTool({ currentUserId: props.currentUserId });

    return (
        <>
            <LabelsSearchBar
                value={searchString}
                onChange={setSearchString}
                handleSearchSubmit={handleSearchSubmit}
                autoFocus
            />
            <Popover.Body className="pb-1.5">
                <LabelLists
                    handleToggleLabelSelection={handleToggleLabelSelection}
                    handleCreateLabel={handleCreateLabel}
                    elements={elements}
                    searchString={searchString}
                    allLabels={allLabels}
                />
            </Popover.Body>
        </>
    );
};

export default LabelsToolbarPopupContent;
